import React from "react";
import "./PortfolioCardItem.scss";
import { portfolio } from "../../../../data/portfolio";
import { FaLink, FaCode } from "react-icons/fa";

const PortfolioCardItem = () => {
  return (
    <>
      {portfolio &&
        portfolio.map((p) => (
          <div
            data-aos="zoom-in"
            className="col-lg-4 col-md-6 col-sm-12 portfolio-card"
            key={p.id}
          >
            <div className="portfolio-card-inner">
              <h4 data-aos="fade-up">{p.name}</h4>
              <div data-aos="zoom-in" className="image">
                <img src={p.image} alt="img" />
              </div>
              <div className="links">
                {p.code ? (
                  <a href={p.code} target="_blank" rel="noreferrer">
                    <FaCode />
                  </a>
                ) : (
                  <></>
                )}
                {p.live ? (
                  <a href={p.live} target="_blank" rel="noreferrer">
                    <FaLink />
                  </a>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        ))}
    </>
  );
};

export default PortfolioCardItem;
